/**
 * Like jQuery's ready handler, this will fire when document.readyState
 * transitions to interactive, or it will get enqueued at the end of the
 * current execution if the readyState has already advanced beyond 'loading'.
 */

export const ready = (fn: () => void) => {
    if (document.readyState == 'loading') {
        document.addEventListener('DOMContentLoaded', fn);
    }
    else {
        setTimeout(fn, 0);
    }
};
